export default {"quantityManagerWrapper":"gfKRO","number":"-vA0s","disabled":"_0qPwD","less":"Pgi52","more":"mmr5U","icon":"AJFAq"};